import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class LogProvider {

    constructor() {
        console.log('Log Provider');
    }
    /**
     * Log data
     * @param name Name
     * @param data Log data
     */
    log(name: string, data: any) {
        if (!environment.production) {
            console.log(name, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/log/log.ts